export default __webpack_public_path__ + "static/emptyBox-3ddd873e668e52549ceb0d2e5cfc660c.webp";